import React from 'react';

function Container({ children }) {
  return (
    <div 
      className="container-fluid bg-white border rounded p-4 my-3 text-center"
      style={{ width: '90%', minHeight: '200px' }}
    >
      {children}
    </div>
  );
}

export default Container;
